
export default {
  name: 'CardLabel',
  props: {
    label: {
      type: String,
      default: undefined,
    },
    isLive: {
      type: Boolean,
      default: false,
    },
    pointView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    text() {
      return this.label || (this.isLive ? 'LIVE' : 'DRAFT');
    },
    statusClass() {
      if (this.label) return this.label === 'TEMPLATE' ? 'template' : 'text-label';
      return this.isLive ? 'live' : 'draft';
    },
    labelClass() {
      return !this.pointView ? this.statusClass : '';
    },
  },
};
